/* eslint-disable */
import React, { useState, useEffect, useCallback } from 'react';
import { getSplitSummary, getBeneficiarySummary, getSplitTransactions, exportSplitReport } from '../services/transactionService';
import { getMerchants } from '../services/merchant';
import { getTenantFromUrl } from '../helpers/http';

const MerchantSelectionModal = ({ onClose, onSelect }) => {
  const [merchants, setMerchants] = useState([]);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const itemsPerPage = 8;

  useEffect(() => {
    const fetchM = async () => {
      setLoading(true);
      try {
        const res = await getMerchants();
        setMerchants(res.data || []);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchM();
  }, []);

  const filtered = merchants.filter(m =>
    m.name?.toLowerCase().includes(search.toLowerCase()) ||
    m.id?.toString().toLowerCase().includes(search.toLowerCase())
  );

  const totalPages = Math.ceil(filtered.length / itemsPerPage);
  const paginated = filtered.slice((page - 1) * itemsPerPage, page * itemsPerPage);

  return (
    <div className="merchant-modal-overlay">
      <div className="merchant-modal-content">
        <div className="merchant-modal-header">
          <h3>Select Merchant</h3>
          <button onClick={onClose} style={{ border: 'none', background: 'transparent', fontSize: '1.5rem', cursor: 'pointer' }}>&times;</button>
        </div>
        <input
          type="text"
          placeholder="Search merchant by name or ID..."
          value={search}
          onChange={(e) => { setSearch(e.target.value); setPage(1); }}
          className="filter-input"
          style={{ margin: '16px', width: 'auto' }}
        />
        <div className="merchant-modal-body">
          {loading ? <div style={{ padding: '20px', textAlign: 'center' }}>Loading merchants...</div> : (
            <div>
              {paginated.map(m => (
                <div key={m.id} className="merchant-list-item" onClick={() => onSelect(m)}>
                  <div style={{ fontWeight: '600', fontSize: '0.9rem', color: '#111' }}>{m.name}</div>
                  <div style={{ fontSize: '0.75rem', color: '#888', marginTop: '4px' }}>ID: {m.id}</div>
                </div>
              ))}
              {paginated.length === 0 && <div style={{ padding: '20px', textAlign: 'center', color: '#666' }}>No merchants found.</div>}
            </div>
          )}
        </div>
        <div className="merchant-modal-footer">
          <button disabled={page === 1} onClick={() => setPage(p => p - 1)}>Prev</button>
          <span style={{ fontSize: '0.8rem', color: '#666' }}>Page {page} of {totalPages || 1}</span>
          <button disabled={page >= totalPages || totalPages === 0} onClick={() => setPage(p => p + 1)}>Next</button>
        </div>
      </div>
      <style>{`
        .merchant-modal-overlay {
          position: fixed; top: 0; left: 0; right: 0; bottom: 0;
          background: rgba(0,0,0,0.5); z-index: 1000;
          display: flex; align-items: center; justify-content: center;
        }
        .merchant-modal-content {
          background: #fff; width: 400px; max-width: 90%; border-radius: 12px;
          display: flex; flex-direction: column; max-height: 85vh; border: 1px solid #eee;
          box-shadow: 0 4px 20px rgba(0,0,0,0.15); font-family: 'Lato', sans-serif;
        }
        .merchant-modal-header {
          display: flex; justify-content: space-between; align-items: center;
          padding: 16px; border-bottom: 1px solid #eee;
        }
        .merchant-modal-header h3 { margin: 0; font-size: 1.1rem; color: #111; }
        .merchant-modal-body {
          padding: 0 16px; overflow-y: auto; flex: 1; min-height: 250px;
        }
        .merchant-list-item {
          padding: 12px; border-bottom: 1px solid #f9f9f9; cursor: pointer; border-radius: 6px; transition: background 0.2s;
        }
        .merchant-list-item:hover { background: #f0f4ff; }
        .merchant-modal-footer {
          display: flex; justify-content: space-between; align-items: center;
          padding: 16px; border-top: 1px solid #eee;
        }
        .merchant-modal-footer button {
          padding: 6px 12px; border: 1.5px solid #e2e0d8; background: #fff; border-radius: 6px; cursor: pointer; font-weight: 600; color: #4a4a6a; transition: all 0.2s;
        }
        .merchant-modal-footer button:hover:not(:disabled) { border-color: #f58220; color: #f58220; }
        .merchant-modal-footer button:disabled { opacity: 0.5; cursor: not-allowed; }
      `}</style>
    </div>
  );
};
const SplitPayment = () => {

  return (
    <div className="min-h-screen bg-[#f7f6f3]">
      <style>{`
        .tab-nav {
          background: #ffffff;
          border-bottom: 1px solid #e2e0d8;
          padding: 0 40px;
          display: flex;
          align-items: center;
          height: 60px;
          position: sticky;
          top: 0;
          z-index: 100;
          font-family: 'Lato', sans-serif;
        }
        .nav-brand {
          font-family: 'Lato', sans-serif;
          font-size: 1.15rem;
          font-weight: 900;
          display: flex;
          align-items: center;
          gap: 8px;
          margin-right: 40px;
          color: #030229;
        }
        .nav-brand .dot {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: #f58220;
        }
        .tab-btn {
          padding: 7px 14px;
          border-radius: 8px;
          font-size: 0.83rem;
          font-weight: 500;
          color: #8888aa;
          background: none;
          border: none;
          cursor: pointer;
          transition: all 0.15s;
          font-family: 'Lato', sans-serif;
        }
        .tab-btn:hover {
          background: #f0efe9;
          color: #4a4a6a;
        }
        .tab-btn.active {
          background: #fff4e6;
          color: #f58220;
          font-weight: 600;
        }
      `}</style>

      <div className="tab-nav">
        <div className="nav-brand">
          <span className="dot"></span> SplitPay
        </div>
      </div>

      <div className="tab-content">
        <SplitReport />
      </div>
    </div>
  );
};

export default SplitPayment;





const SplitReport = () => {
  // --- Constants & Palette ---
  const PALETTE = [
    { bg: '#fff4e6', color: '#f58220' },
    { bg: '#ebfbee', color: '#0ca678' },
    { bg: '#fff4e6', color: '#f76707' },
    { bg: '#f3f0ff', color: '#7048e8' },
    { bg: '#fff5f5', color: '#e03131' },
    { bg: '#e8faf5', color: '#099268' },
    { bg: '#fff9db', color: '#e67700' },
    { bg: '#f0f4ff', color: '#3b5bdb' },
  ];

  const CURRENCY_MAP = {
    "566": "NGN",
    "840": "USD",
    "826": "GBP",
    "978": "EUR",
  };

  const getCurrencyName = (code) => {
    if (code === null || code === undefined || code === '') return '-';
    const str = String(code).trim();
    return CURRENCY_MAP[str] || str;
  };

  const fmtDate = (d) => {
    if (!d) return '';
    return new Date(d).toLocaleDateString('en-NG', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
  };
  const initials = (n) => n ? n.split(' ').slice(0, 2).map(p => p[0]).join('') : '';

  // --- State ---
  const [period, setPeriod] = useState('all');
  const [customRange, setCustomRange] = useState({ from: '', to: '' });
  const [search, setSearch] = useState('');
  const [merchantId, setMerchantId] = useState('');
  const [selectedMerchantName, setSelectedMerchantName] = useState('');
  const [showMerchantModal, setShowMerchantModal] = useState(false);
  const [statusFilter, setStatusFilter] = useState('');
  const [schemeFilter, setSchemeFilter] = useState('');
  const [splitFilter, setSplitFilter] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [openSplitId, setOpenSplitId] = useState(null);

  const [summary, setSummary] = useState({
    totalTransactions: 0,
    totalVolume: 0,
    successful: 0,
    pending: 0,
    withSplitConfig: 0
  });
  const [beneficiariesData, setBeneficiariesData] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(1);

  const [isLoadingStats, setIsLoadingStats] = useState(false);
  const [isLoadingTable, setIsLoadingTable] = useState(false);
  const [isExporting, setIsExporting] = useState(false);

  const pageSize = 10;

  const fetchReportData = useCallback(async () => {
    let dateRangeMapped = 'AllTime';
    if (period === 'today') dateRangeMapped = 'today';
    else if (period === '7d') dateRangeMapped = '7days';
    else if (period === '30d') dateRangeMapped = '30days';
    else if (period === '90d') dateRangeMapped = '90days';
    else if (period === 'all') dateRangeMapped = 'AllTime';
    else if (period === 'custom') dateRangeMapped = 'custom';

    const params = {
      PageNumber: currentPage,
      PageSize: pageSize,
      Search: search,
      MerchantId: merchantId,
      Status: statusFilter,
      Scheme: schemeFilter,
      SplitType: splitFilter === 'none' ? 'None' : (splitFilter === 'simple' ? 'Simple' : (splitFilter === 'complex' ? 'Complex' : '')),
      DateRange: dateRangeMapped,
    };

    if (period === 'custom' && customRange.from && customRange.to) {
      params.From = customRange.from;
      params.To = customRange.to;
    }

    setIsLoadingStats(true);
    setIsLoadingTable(true);

    try {
      const tenant = getTenantFromUrl();
      const [summaryRes, beneRes, txnRes] = await Promise.all([
        getSplitSummary(params, tenant),
        getBeneficiarySummary(params, tenant),
        getSplitTransactions(params, tenant)
      ]);

      if (summaryRes?.success && summaryRes.data) {
        setSummary(summaryRes.data);
      }
      if (beneRes?.success && beneRes.data?.beneficiaries) {
        setBeneficiariesData(beneRes.data.beneficiaries);
      }
      if (txnRes?.success && txnRes.data) {
        setTransactions(txnRes.data.result || []);
        setTotalRecords(txnRes.data.totalRecords ?? 0);
        setTotalPages(txnRes.data.totalPages ?? 1);
      }
    } catch (error) {
      console.error("Failed to fetch split reporting data", error);
    } finally {
      setIsLoadingStats(false);
      setIsLoadingTable(false);
    }
  }, [currentPage, pageSize, search, merchantId, statusFilter, schemeFilter, splitFilter, period, customRange]);

  useEffect(() => {
    if (period === 'custom' && (!customRange.from || !customRange.to)) {
      return;
    }
    fetchReportData();
  }, [fetchReportData]);

  const toggleSplit = (id) => setOpenSplitId(openSplitId === id ? null : id);

  const exportCSV = async () => {
    setIsExporting(true);
    try {
      let dateRangeMapped = 'AllTime';
      if (period === 'today') dateRangeMapped = 'today';
      else if (period === '7d') dateRangeMapped = '7days';
      else if (period === '30d') dateRangeMapped = '30days';
      else if (period === '90d') dateRangeMapped = '90days';
      else if (period === 'all') dateRangeMapped = 'AllTime';
      else if (period === 'custom') dateRangeMapped = 'custom';

      const params = {
        PageNumber: currentPage,
        PageSize: pageSize,
        Search: search,
        MerchantId: merchantId,
        Status: statusFilter,
        Scheme: schemeFilter,
        SplitType: splitFilter === 'none' ? 'None' : (splitFilter === 'simple' ? 'Simple' : (splitFilter === 'complex' ? 'Complex' : '')),
        DateRange: dateRangeMapped,
      };

      if (period === 'custom' && customRange.from && customRange.to) {
        params.From = customRange.from;
        params.To = customRange.to;
      }

      const blob = await exportSplitReport(params);
      const url = window.URL.createObjectURL(new Blob([blob]));
      const a = document.createElement('a');
      a.setAttribute('hidden', '');
      a.setAttribute('href', url);
      a.setAttribute('download', 'split_report.csv');
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.error("Export failed", error);
    } finally {
      setIsExporting(false);
    }
  };

  const renderPageBtns = () => {
    const pages = [];
    for (let i = 1; i <= (totalPages || 1); i++) {
      if (i === 1 || i === totalPages || (i >= currentPage - 1 && i <= currentPage + 1)) {
        pages.push(i);
      } else if (i === currentPage - 2 || i === currentPage + 2) {
        pages.push('...');
      }
    }
    const visiblePages = [...new Set(pages)];
    return visiblePages.map((p, idx) => (
      <button key={idx} className={`page-btn ${currentPage === p ? 'active' : ''}`} disabled={p === '...'} onClick={() => p !== '...' && setCurrentPage(p)}>{p}</button>
    ));
  };

  return (
    <div className="split-report-container">
      <style>{`
        :root {
          --bg: #fafafa; --white: #ffffff; --surface: #f0efe9; --border: #e2e0d8;
          --border-dark: #ccc9bf; --accent: #f58220; --accent-light: #fff4e6;
          --accent2: #0ca678; --accent2-light: #ebfbee; --accent3: #bb4430;
          --accent3-light: #fff5f5; --accent4: #f76707; --accent4-light: #fff4e6;
          --accent5: #7048e8; --accent5-light: #f3f0ff; --text: #030229;
          --text-mid: #4a4a6a; --text-dim: #8888aa; --text-muted: #b0b0c8;
          --shadow: 0 1px 4px rgba(26,26,46,0.07), 0 4px 16px rgba(26,26,46,0.05);
          --shadow-md: 0 2px 8px rgba(26,26,46,0.09), 0 8px 32px rgba(26,26,46,0.07);
          --radius: 14px; --radius-sm: 9px;
        }
        .split-report-container { background: var(--bg); color: var(--text); font-family: 'Lato', sans-serif; min-height: 100vh; padding: 24px; }
        .page-title { display: flex; align-items: flex-start; justify-content: space-between; flex-wrap: wrap; gap: 16px; margin-bottom: 28px; }
        .page-title h1 { font-family: 'Lato', sans-serif; font-size: 1.75rem; font-weight: 900; letter-spacing: -0.03em; line-height: 1.15; }
        .page-title p { color: var(--text-dim); font-size: 0.84rem; margin-top: 5px; }
        .stats-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(170px, 1fr)); gap: 12px; margin-bottom: 28px; }
        .stat-card { background: var(--white); border: 1px solid var(--border); border-radius: var(--radius); padding: 18px 20px; box-shadow: var(--shadow); }
        .stat-label { font-size: 0.68rem; font-weight: 600; letter-spacing: 0.08em; text-transform: uppercase; color: var(--text-dim); margin-bottom: 8px; display: flex; align-items: center; gap: 6px; }
        .stat-val { font-family: 'Lato', sans-serif; font-size: 1.5rem; font-weight: 900; letter-spacing: -0.02em; line-height: 1; min-height: 24px; }
        .stat-sub { font-size: 0.72rem; color: var(--text-dim); margin-top: 5px; }
        .c-blue { color: var(--accent); } .c-green { color: var(--accent2); } .c-orange { color: var(--accent4); } .c-red { color: var(--accent3); } .c-purple { color: var(--accent5); }
        .section-head { display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 12px; margin-bottom: 16px; }
        .section-title { font-family: 'Lato', sans-serif; font-size: 1.1rem; font-weight: 700; color: var(--text); letter-spacing: -0.02em; }
        .section-title small { font-family: 'Lato', sans-serif; font-size: 0.75rem; font-weight: 500; color: var(--text-dim); margin-left: 8px; }
        .period-filters { display: flex; gap: 6px; align-items: center; flex-wrap: wrap; }
        .period-btn { padding: 6px 14px; border-radius: 20px; border: 1.5px solid var(--border); background: var(--white); font-family: 'Lato', sans-serif; font-size: 0.75rem; font-weight: 600; color: var(--text-dim); cursor: pointer; transition: all 0.15s; }
        .period-btn:hover { border-color: var(--accent); color: var(--accent); }
        .period-btn.active { background: var(--accent); border-color: var(--accent); color: #fff; }
        .custom-date-wrap { display: flex; gap: 6px; align-items: center; }
        .custom-date-wrap input[type="date"] { background: var(--white); border: 1.5px solid var(--border); color: var(--text); font-family: 'Lato', sans-serif; font-size: 0.75rem; padding: 6px 10px; border-radius: 8px; outline: none; transition: border-color 0.15s; cursor: pointer; }
        .bene-cards-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(240px, 1fr)); gap: 14px; margin-bottom: 36px; }
        .bene-card { background: var(--white); border: 1px solid var(--border); border-radius: var(--radius); padding: 20px; box-shadow: var(--shadow); transition: box-shadow 0.18s, transform 0.18s; animation: fadeUp 0.22s ease both; }
        .bene-card:hover { box-shadow: var(--shadow-md); transform: translateY(-2px); }
        @keyframes fadeUp { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
        .bene-avatar { width: 40px; height: 40px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-family: 'Lato', sans-serif; font-size: 1rem; font-weight: 700; flex-shrink: 0; margin-right: 12px; }
        .bene-name { font-size: 0.88rem; font-weight: 600; color: var(--text); line-height: 1.2; }
        .bene-total { font-family: 'Lato', sans-serif; font-size: 1.4rem; font-weight: 900; letter-spacing: -0.02em; color: var(--text); }
        .bene-bar-track { height: 5px; border-radius: 3px; background: var(--surface); overflow: hidden; margin-top: 14px; }
        .bene-bar-fill { height: 100%; border-radius: 3px; transition: width 0.6s ease; }
        .bene-pct { font-size: 0.7rem; color: var(--text-dim); text-align: right; margin-top: 4px; }
        .bene-rule-tag { display: inline-block; font-size: 0.65rem; font-weight: 600; padding: 2px 8px; border-radius: 20px; margin-top: 8px; }
        .filters-bar { display: flex; gap: 10px; flex-wrap: wrap; align-items: center; margin-bottom: 16px; }
        .filter-input { background: var(--white); border: 1.5px solid var(--border); color: var(--text); font-family: 'Lato', sans-serif; font-size: 0.82rem; padding: 9px 13px; border-radius: var(--radius-sm); outline: none; transition: border-color 0.15s; width: 220px; }
        select.filter-input { appearance: none; cursor: pointer; width: auto; padding-right: 32px; background-repeat: no-repeat; background-position: right 12px center; background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath d='M1 1l5 5 5-5' stroke='%238888aa' stroke-width='1.5' fill='none' stroke-linecap='round'/%3E%3C/svg%3E"); }
        .table-card { background: var(--white); border: 1px solid var(--border); border-radius: var(--radius); box-shadow: var(--shadow); overflow: hidden; margin-bottom: 16px; min-height: 200px; }
        .table-scroll { overflow-x: auto; }
        table { width: 100%; border-collapse: collapse; min-width: 900px; }
        thead { background: var(--surface); border-bottom: 2px solid var(--border); }
        th { text-align: left; padding: 11px 14px; font-size: 0.68rem; font-weight: 700; letter-spacing: 0.06em; text-transform: uppercase; color: var(--text-dim); white-space: nowrap; }
        td { padding: 13px 14px; font-size: 0.82rem; vertical-align: middle; }
        tr.txn-main:hover { background: #fafaf8; }
        .split-row td { padding: 0; background: var(--bg); }
        .split-row-inner { display: grid; grid-template-rows: 0fr; transition: grid-template-rows 0.28s ease; }
        .split-row-inner.open { grid-template-rows: 1fr; }
        .split-row-overflow { overflow: hidden; padding: 0 14px; transition: padding 0.28s ease; }
        .split-row-inner.open .split-row-overflow { padding: 0 14px 14px; }
        .split-block { background: var(--white); border: 1.5px solid var(--border); border-radius: var(--radius-sm); overflow: hidden; margin-top: 8px; margin-bottom: 8px;}
        .split-block-head { display: flex; align-items: center; gap: 8px; padding: 8px 14px; background: var(--surface); border-bottom: 1px solid var(--border); }
        .split-items { display: flex; flex-wrap: wrap; }
        .split-item { display: flex; align-items: center; gap: 10px; padding: 10px 14px; border-right: 1px solid var(--border); min-width: 200px; flex: 1; }
        .split-item-amount { margin-left: auto; font-family: 'Lato', sans-serif; font-weight: 700; color: var(--accent2); }
        .split-toggle-btn { display: inline-flex; align-items: center; gap: 6px; padding: 4px 10px; border-radius: 20px; border: 1.5px solid var(--border); background: var(--white); font-size: 0.72rem; font-weight: 600; color: var(--text-dim); cursor: pointer; transition: all 0.16s; }
        .split-toggle-btn.has-split { border-color: rgba(26,86,219,0.25); color: var(--accent); background: var(--accent-light); }
        .split-toggle-btn.open { background: var(--accent); border-color: var(--accent); color: #fff; }
        .status-badge { display: inline-flex; align-items: center; justify-content: center; gap: 5px; padding: 3px 9px; border-radius: 20px; font-size: 0.68rem; font-weight: 700; }
        .s-approved, .s-successful { background: var(--accent2-light); color: var(--accent2); }
        .s-pending { background: var(--accent4-light); color: var(--accent4); }
        .s-failed { background: var(--accent3-light); color: var(--accent3); }
        .scheme-badge { font-size: 0.68rem; font-weight: 700; padding: 2px 8px; border-radius: 5px; }
        .sc-visa { background: var(--accent-light); color: var(--accent); }
        .sc-mastercard, .sc-mc { background: var(--accent3-light); color: var(--accent3); }
        .sc-verve { background: var(--accent2-light); color: var(--accent2); }
        .pagination-row { display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 10px; font-size: 0.78rem; color: var(--text-dim); margin-top: 16px; }
        .page-btns { display: flex; gap: 4px; }
        .page-btn { min-width: 34px; height: 34px; background: var(--white); border: 1.5px solid var(--border); border-radius: 8px; cursor: pointer; display: flex; align-items: center; justify-content: center; font-weight: 600; }
        .page-btn.active { background: var(--accent); border-color: var(--accent); color: #fff; }
        .page-btn:disabled { opacity: 0.3; cursor: not-allowed; }
        .export-btn { background: var(--accent); color: #fff; border: none; font-size: 0.8rem; font-weight: 600; padding: 7px 16px; border-radius: 8px; cursor: pointer; margin-left: auto; }
        .loading-state { padding: 40px; text-align: center; color: var(--text-dim); }
        .split-color-dot { width: 8px; height: 8px; border-radius: 50%; }
        .no-bene { padding: 30px; text-align: center; color: var(--text-dim); background: var(--white); border: 1px dashed var(--border); border-radius: var(--radius); }
        .label-text { font-size: 0.75rem; font-weight: 700; }
        .split-item-name { font-size: 0.82rem; font-weight: 600; color: var(--text); }
      `}</style>

      <div className="page-title">
        <div>
          <h1>Transaction Report</h1>
          <p>Transaction log with split allocation details per transaction</p>
        </div>
        <button className="export-btn" onClick={exportCSV} disabled={isExporting}>{isExporting ? 'Exporting...' : '↓ Export CSV'}</button>
      </div>
      {selectedMerchantName && <h2 className='font-bold text-xl mb-4'>Report for {selectedMerchantName}</h2>}

      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-label">📋 Transactions</div>
          <div className="stat-val c-blue">{isLoadingStats ? '...' : summary.totalTransactions}</div>
          <div className="stat-sub">All records</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">💰 Total Volume</div>
          <div className="stat-val c-green">{isLoadingStats ? '...' : `${(summary.totalVolume || 0).toLocaleString()}`}</div>
          <div className="stat-sub">Successful only</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">✅ Successful</div>
          <div className="stat-val c-green">{isLoadingStats ? '...' : summary.successful}</div>
          <div className="stat-sub">Transactions</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">⏳ Pending</div>
          <div className="stat-val c-orange">{isLoadingStats ? '...' : summary.pending}</div>
          <div className="stat-sub">Transactions</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">🔀 Split</div>
          <div className="stat-val c-purple">{isLoadingStats ? '...' : summary.withSplitConfig}</div>
          <div className="stat-sub">With split config</div>
        </div>
      </div>

      <div className="section-head">
        <div className="section-title">Beneficiary Cumulative Summary <small>{period === 'all' ? 'All time' : period === 'custom' ? `${customRange.from} to ${customRange.to}` : period}</small></div>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <div className="period-filters">
            {['all', 'today', '7d', '30d', '90d', 'custom'].map(p => (
              <button key={p} className={`period-btn ${period === p ? 'active' : ''}`} onClick={() => setPeriod(p)}>
                {p === 'all' ? 'All Time' : p === '7d' ? '7 Days' : p === '30d' ? '30 Days' : p === '90d' ? '90 Days' : p.charAt(0).toUpperCase() + p.slice(1)}
              </button>
            ))}
          </div>
          {period === 'custom' && (
            <div className="custom-date-wrap">
              <input type="date" value={customRange.from} onChange={e => setCustomRange({ ...customRange, from: e.target.value })} />
              <span>to</span>
              <input type="date" value={customRange.to} onChange={e => setCustomRange({ ...customRange, to: e.target.value })} />
            </div>
          )}
        </div>
      </div>

      <div className="bene-cards-grid">
        {isLoadingStats ? <div className="loading-state" style={{ gridColumn: '1 / -1' }}>Loading beneficiary data...</div> : beneficiariesData.length === 0 ? <div className="no-bene" style={{ gridColumn: '1 / -1' }}>No beneficiary data for this period.</div> :
          beneficiariesData.map((bene, idx) => {
            const name = bene.beneficiaryName;
            const data = { count: bene.transactionCount, total: bene.totalReceived, keyword: bene.keywords?.join(', ') };
            const pal = PALETTE[idx % PALETTE.length];
            const pct = bene.percentageOfTotal || 0;
            return (
              <div key={name} className="bene-card">
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
                  <div className="bene-avatar" style={{ background: pal.bg, color: pal.color }}>{initials(name)}</div>
                  <div>
                    <div className="bene-name">{name}</div>
                    <div style={{ fontSize: '0.72rem', color: 'var(--text-dim)' }}>{data.count} txns</div>
                  </div>
                </div>
                <div className="bene-total">₦{(data.total || 0).toLocaleString()}</div>
                <div className="bene-bar-wrap">
                  <div className="bene-bar-track"><div className="bene-bar-fill" style={{ width: `${pct}%`, background: pal.color }}></div></div>
                  <div className="bene-pct">{pct}% of total successful volume</div>
                </div>
                {data.keyword && <span className="bene-rule-tag" style={{ background: pal.bg, color: pal.color }}>Keyword(s): {data.keyword}</span>}
              </div>
            );
          })}
      </div>

      <div className="section-head" style={{ marginTop: 8 }}>
        <div className="section-title">Transactions</div>
      </div>

      <div className="filters-bar">
        <input type="text" className="filter-input" placeholder="Search name, ref, description…" value={search} onChange={e => { setSearch(e.target.value); setCurrentPage(1); }} />
        <div style={{ position: 'relative', display: 'inline-block' }}>
          <button className="filter-input" onClick={() => setShowMerchantModal(true)} style={{ textAlign: 'left', background: 'var(--white)', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '170px' }}>
              {selectedMerchantName ? `Merchant: ${selectedMerchantName}` : 'Filter by Merchant...'}
            </span>
            {selectedMerchantName ? (
              <span onClick={(e) => { e.stopPropagation(); setMerchantId(''); setSelectedMerchantName(''); setCurrentPage(1); }} style={{ marginLeft: '8px', cursor: 'pointer', color: '#888', fontWeight: 'bold' }}>&times;</span>
            ) : (
              <span style={{ marginLeft: '8px', color: '#888' }}>▼</span>
            )}
          </button>
        </div>
        <select className="filter-input" value={statusFilter} onChange={e => { setStatusFilter(e.target.value); setCurrentPage(1); }}>
          <option value="">All Statuses</option>
          <option value="APPROVED">Approved / Successful</option>
          <option value="PENDING">Pending</option>
          <option value="FAILED">Failed</option>
        </select>
        <select className="filter-input" value={schemeFilter} onChange={e => { setSchemeFilter(e.target.value); setCurrentPage(1); }}>
          <option value="">All Schemes</option>
          <option value="Visa">Visa</option>
          <option value="MC">Mastercard</option>
          <option value="Verve">Verve</option>
          <option value="Amex">Amex</option>
        </select>
        <select className="filter-input" value={splitFilter} onChange={e => { setSplitFilter(e.target.value); setCurrentPage(1); }}>
          <option value="">All Split Types</option>
          <option value="simple">Simple</option>
          <option value="complex">Complex</option>
          <option value="none">No Split</option>
        </select>
      </div>

      <div className="table-card">
        <div className="table-scroll">
          {isLoadingTable ? <div className="loading-state">Loading transactions...</div> : transactions.length === 0 ? <div className="loading-state">No transactions found.</div> : (
            <table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Description</th>
                  <th>Amount</th>
                  <th>Currency</th>
                  <th>Date</th>
                  <th>Status</th>
                  <th>Masked PAN</th>
                  <th>Scheme</th>
                  <th>Customer Name</th>
                  <th>Email</th>
                  <th>Reference ID</th>
                  <th>Split</th>
                </tr>
              </thead>
              <tbody>
                {transactions.map(t => (
                  <React.Fragment key={t.id}>
                    <tr className="txn-main">
                      <td>{t.id}</td>
                      <td><b>{t.description}</b></td>
                      <td><b>{getCurrencyName(t.currency)} {(t.amount || 0).toLocaleString()}</b></td>
                      <td>{getCurrencyName(t.currency)}</td>
                      <td>{fmtDate(t.initiated)}</td>
                      <td><span className={`status-badge s-${(t.status || '').toLowerCase()}`}>{t.status}</span></td>
                      <td><code>{t.maskedPan}</code></td>
                      <td><span className={`scheme-badge sc-${(t.scheme || '').toLowerCase()}`}>{t.scheme}</span></td>
                      <td>{t.customerName}</td>
                      <td>{t.customerEmail}</td>
                      <td><small>{t.referenceId}</small></td>
                      <td>
                        <button className={`split-toggle-btn ${t.splitType && t.splitType !== 'None' ? 'has-split' : ''} ${openSplitId === t.id ? 'open' : ''}`} onClick={() => toggleSplit(t.id)}>
                          {t.splitType && t.splitType !== 'None' ? 'View Split' : 'No Split'} {openSplitId === t.id ? '▲' : '▼'}
                        </button>
                      </td>
                    </tr>
                    <tr className="split-row">
                      <td colSpan="12">
                        <div className={`split-row-inner ${openSplitId === t.id ? 'open' : ''}`}>
                          <div className="split-row-overflow">
                            {t.splitType && t.splitType !== 'None' ? (
                              <div className="split-block">
                                <div className="split-block-head">
                                  <span className="label-text">Split Allocation ({t.splitType})</span>
                                  {t.triggerKeyword && <span className="bene-rule-tag" style={{ background: '#eee', color: '#666', marginLeft: 8 }}>Keyword: {t.triggerKeyword}</span>}
                                </div>
                                <div className="split-items">
                                  {t.allocations?.map((sub, idx) => {
                                    return (
                                      <div key={idx} className="split-item">
                                        <div className="split-color-dot" style={{ background: PALETTE[idx % PALETTE.length].color }}></div>
                                        <div>
                                          <div className="split-item-name">{sub.beneficiaryName}</div>
                                          <div style={{ fontSize: '0.72rem', color: 'var(--text-dim)' }}>{sub.allocationType === 'Percentage' ? `${sub.percentage}%` : (sub.allocationType === 'Flat' ? 'Flat Amount' : 'Residual')}</div>
                                        </div>
                                        <div className="split-item-amount">₦{(sub.allocatedAmount || 0).toLocaleString()}</div>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            ) : null}
                          </div>
                        </div>
                      </td>
                    </tr>
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>

      <div className="pagination-row">
        <span>Showing {Math.min((currentPage - 1) * pageSize + 1, totalRecords || 0)} to {Math.min(currentPage * pageSize, totalRecords || 0)} of {totalRecords || 0} entries</span>
        <div className="page-btns">
          <button className="page-btn" disabled={currentPage === 1} onClick={() => setCurrentPage(currentPage - 1)}>Prev</button>
          {renderPageBtns()}
          <button className="page-btn" disabled={currentPage >= totalPages || totalPages === 0} onClick={() => setCurrentPage(currentPage + 1)}>Next</button>
        </div>
      </div>

      {showMerchantModal && (
        <MerchantSelectionModal
          onClose={() => setShowMerchantModal(false)}
          onSelect={(m) => {
            setMerchantId(m.id);
            setSelectedMerchantName(m.name);
            setShowMerchantModal(false);
            setCurrentPage(1);
          }}
        />
      )}
    </div>
  );
};
